import { Component, Input, Output, EventEmitter, type OnInit, inject } from "@angular/core"
import { CommonModule } from "@angular/common"
import { AbstractControl, FormBuilder, type FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from "@angular/forms"
import { FunctionalType } from "src/app/enums/functional-type"
import { DropdownOption } from "src/app/models/shared/dropdown-option"
import { DropdownComponent } from "src/app/components/shared/dropdown/dropdown.component"

function atLeastOneSelected(control: AbstractControl): ValidationErrors | null {
  const eligibleCompany = control.get("eligibleCompany")?.value;
  const eligibleCandidate = control.get("eligibleCandidate")?.value;
  const eligibleFreelance = control.get("eligibleFreelance")?.value;

  if (eligibleCompany || eligibleCandidate || eligibleFreelance) {
    return null;
  }
  return { atLeastOne: true };
}

@Component({
  selector: "app-type-public-step",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DropdownComponent],
  templateUrl: "./type-public-step.component.html",
  styleUrls: ["./type-public-step.component.css"],
})
export class TypePublicStepComponent implements OnInit {
  @Input() public isReadonly: boolean = false;
  @Input() formData: any = {}
  @Input() availableServicesOptions: DropdownOption[] = [];
  @Input() functionalTypeOptions: DropdownOption[] = [];
  @Output() dataChange = new EventEmitter<any>()

  private fb = inject(FormBuilder)
  form!: FormGroup

  functionalType = FunctionalType;


  ngOnInit() {
    this.form = this.fb.group({
      functionalTypeId: [this.formData.functionalTypeId || this.functionalType.Service],
      functionalType: [this.formData?.functionalType ?? ''],
      serviceId: [this.formData.serviceId || null, [Validators.required]],
      service: [this.formData?.service ?? ''],
      eligibleCompany: [this.formData.eligibleCompany || false],
      eligibleCandidate: [this.formData.eligibleCandidate || false],
      eligibleFreelance: [this.formData.eligibleFreelance || false],
    }, { validators: atLeastOneSelected })

    if (this.formData?.functionalTypeId === this.functionalType.Service) {
      this.form.get('serviceId')?.setValidators([Validators.required]);
    } else {
      this.form.get('serviceId')?.clearValidators();
    }
    this.form.get('serviceId')?.updateValueAndValidity({
      emitEvent: false
    });

    this.form.valueChanges.subscribe((value) => {
      this.dataChange.emit(value)
      if (value?.functionalTypeId === this.functionalType.Service) {
        this.form.get('serviceId')?.setValidators([Validators.required]);
      } else {
        this.form.get('serviceId')?.clearValidators();
      }
      this.form.get('serviceId')?.updateValueAndValidity({
        emitEvent: false
      });
    })
  }

  selectType(type: FunctionalType) {
    this.form.get("functionalTypeId")?.setValue(type)
  }

  validate() {
    const isValid = this.form.valid;
    if (!isValid) {
      this.form.markAllAsTouched()
    }
    return isValid;
  }

}